import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungWuppertal() {
  return (
    <CityPageTemplate
      city="Wuppertal"
      slug="wuppertal"
      intro="Wuppertal hat mehr zu bieten als die Schwebebahn – auch beim Thema Finanzen setzen wir neue Maßstäbe."
      description="Unabhängige Finanzberatung für Wuppertal – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
